import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  DefaultUnitTypeEnum,
  H2FacilityForm,
  HydrogenQualityEnum,
  HydrogenSectorOfLocationEnum,
  HydrogenUtilizationEnum,
  RegisterH2FacilityForm,
  UnitForm,
} from '../../../../interfaces/register_location';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FacilityH2Type } from '@enums';
import { number_regex } from '@regex';
import { specialChars } from '../../../../../../shared/constants/form-constants';

@UntilDestroy()
@Component({
  selector: 'app-register-h2-years-form',
  templateUrl: './register-h2-years-form.component.html',
  styleUrls: ['./register-h2-years-form.component.scss'],
})
export class RegisterH2YearsFormComponent {
  @Input()
  public form: FormGroup<RegisterH2FacilityForm>;
  @Input()
  public years: number[];
  @Input()
  public isUserVNB: boolean;
  @Input()
  public isEdit: boolean = false;
  @Output()
  public setPage: EventEmitter<1 | 2> = new EventEmitter<1 | 2>();
  public readonly facilityTypeEnum = FacilityH2Type;
  public readonly defaultUnitTypeEnum = DefaultUnitTypeEnum;
  public readonly NUMBER_REGEX = number_regex;
  public readonly specialChars_regex = specialChars;
  public readonly hydrogenQualityArray = Object.keys(HydrogenQualityEnum)
    .filter(key => !isNaN(Number(HydrogenQualityEnum[key])))
    .map(key => ({ label: key, value: HydrogenQualityEnum[key] }));
  public readonly hydrogenUtilizationArray = Object.keys(
    HydrogenUtilizationEnum
  )
    .filter(key => !isNaN(Number(HydrogenUtilizationEnum[key])))
    .map(key => ({ label: key, value: HydrogenUtilizationEnum[key] }));
  public readonly hydrogenSectorOfLocationArray = Object.keys(
    HydrogenSectorOfLocationEnum
  )
    .filter(key => !isNaN(Number(HydrogenSectorOfLocationEnum[key])))
    .map(key => ({ label: key, value: HydrogenSectorOfLocationEnum[key] }));

  public get maloIdControl(): FormControl {
    return this.form?.controls.facility.controls.maloId;
  }

  public get facilityForm(): FormGroup<H2FacilityForm> {
    return this.form?.controls.facility as FormGroup;
  }

  public get capacityForm(): FormGroup<UnitForm> {
    return this.form?.controls.capacity as FormGroup;
  }

  public get energyForm(): FormGroup<UnitForm> {
    return this.form?.controls.energy as FormGroup;
  }

  public get capacityYearsForm(): FormGroup {
    return this.capacityForm?.controls.years;
  }

  public get energyYearsForm(): FormGroup {
    return this.energyForm?.controls.years;
  }

  public getControlIsInvalid(year: number): boolean {
    return this.energyYearsForm.get(year.toString()).invalid;
  }

  public getHydrogenQualityText(label: string) {
    return `registration.hydrogen_quality.${label}`;
  }
}
